import { Champ } from './champ';

export class ContenuPdf {
    public reference: string;
    public typeAvis: string;
    public langue: string;
    public champs: Map<string, Array<Champ>>;
    public formulaireAdapte: boolean;
    
    constructor(){
        this.reference = '';
        this.typeAvis = '';
        this.langue = '';
        this.champs = new Map<string, Array<Champ>>();
        this.formulaireAdapte = false;
    }

}
